import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { useCdnImage, getAssetSet } from '../../app/context/config'; // ../app/context/config
import { Text } from '../index';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Image from '../chrome/Image';

const assetSet = (filename) => getAssetSet(useCdnImage, filename);

const imageContainerBaseStyles = () => css`
  display: flex;
  justify-content: center;
  max-width: 250px;
`;

const imageContainerStyles = ({ theme }) =>
  css`
    width: 100%;
    max-width: 100%;
    background-color: ${theme.colors.white};
    flex-direction: column;
  `;

const ImageContainer = styled('div')(imageContainerBaseStyles, imageContainerStyles); //, imageContainerSizeStyles

const LeaderboardResultsDivider = ({ playerCount }) => {
  const { strings } = useSelector((state) => state);
  const resultDividerImg = assetSet(['leaderboardResultsDivider']);
  const position = 'center';
  return (
    <ImageContainer position={position}>
      <Image src={resultDividerImg} alt='' />
      <Text as='p' size='tera' centered bold>
        {strings['leaderboard/table/localPos'](`${playerCount}`)}
      </Text>
      <Text as='p' size='giga' centered>
        {strings['leaderboard/table/localPosPep']}
      </Text>
    </ImageContainer>
  );
};
LeaderboardResultsDivider.propTypes = {
  playerCount: PropTypes.number,
};

export default LeaderboardResultsDivider;
